/*
 * Copyright (c) 2024. Tooling Team
 */

import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./services/baseApi";
import { medDomainApi } from "./services/medDomainApi";
import { medDomainEISApi } from "./services/medDomainEISApi";
import { mapSlice } from "./slices/EIPMapValueDefinition.slice";
import { createMapSlice } from "./slices/EIPCreateMap.slice";
import { cloneSlice } from "./slices/clone.slice";
import { medDomainSlice } from "./slices/medDomain.slice";
import { medDomainEISSlice } from "./slices/medDomainEIS.slice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    [medDomainApi.reducerPath]: medDomainApi.reducer,
    [medDomainEISApi.reducerPath]: medDomainEISApi.reducer,
    [medDomainEISSlice.name]: medDomainEISSlice.reducer,
    // Mount createSlice reducers explicitly under stable keys
    map: mapSlice.reducer,
    createMap: createMapSlice.reducer,
    clone: cloneSlice.reducer,
    medDomain: medDomainSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(baseApi.middleware)
      .concat(medDomainApi.middleware)
      .concat(medDomainEISApi.middleware),
});
